module.exports = __webpack_public_path__ + "img/ejoyEnglish.a3b09157.svg";